import HorizontalBarChart from "../../../../../src/core/HorizontalBarChart";
import { Playground } from 'docz';
import * as React from 'react';
export default {
  HorizontalBarChart,
  Playground,
  React
};